import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export interface AARPCheckboxProps {
  isAARPChecked: boolean;
  onAARPChange: () => void;
}

export const AARPCheckbox: React.FunctionComponent<AARPCheckboxProps> = ({ onAARPChange, isAARPChecked }) => {
  const { formatText } = useLocalization();
  const checkboxValue = isAARPChecked ? "on" : "off";

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="aarp-checkbox-toggle"
          label={formatText(locKeys.aarpLabel)}
          description={formatText(locKeys.aarpDescription)}
          checked={isAARPChecked}
          onChange={onAARPChange}
        />
        <input type="hidden" name="aarpcr" value={checkboxValue} data-testid="aarp-input" />
      </div>
    </UitkLayoutGridItem>
  );
};
